"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATE_FORMAT = void 0;
// default date format used on client
exports.DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
//# sourceMappingURL=platform.js.map